import { ThemeControl as AppearanceThemeControl } from "@/theme/theme-control";
import { cn } from "@/utils/tailwind";

import { ColorThemeControl } from "./color-theme-control";

interface ThemeControlProps {
  className?: string;
}

// Keep the independent color and appearance preferences in one compact control.
export function ThemeControl({ className }: ThemeControlProps) {
  return (
    <div className={cn("flex items-center gap-1", className)}>
      <ColorThemeControl />
      <AppearanceThemeControl />
    </div>
  );
}
